export default {
  hero: {
    tagline:
      "一款基于 SwiftUI 的原生 macOS Minecraft 启动器，提供流畅的性能、完整的模组加载器支持、Microsoft 账户登录和直观的游戏管理。",
    requirement: "需要 macOS 14.0 或更高版本",
    loading: "获取最新版本...",
    fetchError: "获取版本失败",
    download: "下载",
    appleChip: "Apple 芯片",
    intel: "Intel",
  },
  features: {
    title: "强大功能，一目了然",
    subtitle: "从账户登录到模组管理，把复杂的操作变得简单。",
    items: [
      {
        title: "原生 Swift，快如闪电",
        body: "基于 SwiftUI 打造，启动迅捷、界面流畅，完整支持深色模式与 macOS 系统特性，带来真正原生的使用体验。",
      },
      {
        title: "Microsoft 账户，一步登录",
        body: "安全连接 Microsoft 与 Xbox 账户，轻松管理多个角色，随时切换，登录状态长久保持。",
      },
      {
        title: "皮肤管理，随心切换",
        body: "内置皮肤预览与管理，随时查看角色外观，一键切换皮肤，所见即所得。",
      },
    ],
    moreTitle: "还有更多",
    moreCta: "还有更多功能，等你在启动器里亲自发现。",
    moreCtaLink: "下载启动器开始探索",
    more: [
      {
        title: "模组加载器",
        body: "Fabric、Forge、NeoForge 与 Quilt 全支持，一键安装、一键切换。",
      },
      {
        title: "游戏实例",
        body: "多版本、多实例独立配置，模组与存档互不干扰。",
      },
      {
        title: "自动更新",
        body: "基于 Sparkle 框架的自动更新，新版本发布后第一时间提示升级。",
      },
      {
        title: "原生界面",
        body: "界面完全采用 macOS 原生控件与设计语言，自动跟随系统深浅色外观，与系统浑然一体。",
      },
      {
        title: "多语言",
        body: "界面支持 22 种语言，覆盖全球主流地区。",
      },
      {
        title: "开源免费",
        body: "基于 AGPL v3 开源，代码透明，永久免费使用。",
      },
    ],
  },
  contributors: {
    github: "GitHub贡献者",
    core: "核心贡献者",
    contributions: "次贡献",
  },
  navbar: {
    docs: "文档",
    changelog: "版本历史",
    discussions: "讨论区",
    reportIssue: "报告问题",
  },
  footer: {
    product: "产品",
    download: "下载",
    userGuide: "用户指南",
    changelog: "版本历史",
    community: "社区",
    discussions: "讨论区",
    qqGroup: "QQ群",
    bilibili: "Bilibili",
    feedback: "反馈",
    reportIssue: "报告问题",
    legal: "协议",
    license: "AGPL v3 许可证",
    copyright: "保留所有权利。",
    disclaimer:
      "Swift Craft Launcher 不隶属于 Mojang Studios 或 Microsoft。Minecraft 是 Mojang Studios 的注册商标。",
  },
};
